export default __webpack_public_path__ + "static/media/Resolucion_23_acta_9.7f429301.pdf";